module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-bar",
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "icon",
    style: ({
      'background-color': _vm.color
    })
  }, [_c('span', {
    class: {
      en: _vm.language === 'ch' ? true : false
    }
  }, [_vm._v(_vm._s(_vm.text))])]), _vm._v(" "), (_vm.data.navType == 5) ? _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "14px",
      "cursor": "pointer"
    },
    style: ({
      color: _vm.color
    }),
    on: {
      "click": _vm.more
    }
  }, [_vm._v(_vm._s(_vm.$t("message.more")) + "》")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bf29f1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl1/topBar/topBar.vue
// module id = 799
// module chunks = 10